import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  ArrayField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  // RichTextInput,
  ArrayInput,
  SimpleFormIterator,
  Create,
  Show,
  SimpleShowLayout,
  BooleanField,
  BooleanInput,
} from 'react-admin'
import { languages } from '../config/constants'

// import { CustomRichTextInput } from '../components/CustomRichTextInput'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ChecklistList = ({ isEdit, isDelete }) => (
  <List filters={[
    <BooleanInput key="filter-isPaymentRequired" source="isPaymentRequired" />,
  ]}>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <RichTextField source="description" />
      <BooleanField source="isPaymentRequired" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const ChecklistEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" fullWidth />
      <TextInput source="description" fullWidth multiline rows={2} />
      <BooleanInput source="isPaymentRequired" />
      <ArrayInput source="checks">
        <SimpleFormIterator
          fullWidth
          getItemLabel={(index) => `#${index + 1}`}
          sx={{
            // Keep the item label from growing and colliding with iterator action buttons
            '& .RaSimpleFormIterator-index': {
              display: 'block !important',
              width: '4ch',
              minWidth: '4ch',
              maxWidth: '4ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '@media (max-width: 899.95px)': {
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
              },
            },
            // Inputs area becomes 1col on mobile, 2col on big screens
            '& .RaSimpleFormIterator-form': {
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' },
              gap: 1,
              alignItems: 'flex-start',
              width: '100%',
              pt: 1.5,
              flex: '1 1 auto',
              minWidth: 0,
            },
            '& .RaSimpleFormIterator-action': {
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
          }}
        >
          {languages.map((lang) => (
            <TextInput key={lang.id} source={lang.id} label={lang.label} fullWidth />
          ))}
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
)

export const ChecklistCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" fullWidth />
      <TextInput source="description" fullWidth multiline rows={2} />
      <BooleanInput source="isPaymentRequired" />
      <ArrayInput source="checks">
        <SimpleFormIterator
          fullWidth
          getItemLabel={(index) => `#${index + 1}`}
          sx={{
            // Keep the item label from growing and colliding with iterator action buttons
            '& .RaSimpleFormIterator-index': {
              display: 'block !important',
              width: '4ch',
              minWidth: '4ch',
              maxWidth: '4ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '@media (max-width: 899.95px)': {
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
              },
            },
            // Inputs area becomes 1col on mobile, 2col on big screens
            '& .RaSimpleFormIterator-form': {
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' },
              gap: 1,
              alignItems: 'flex-start',
              width: '100%',
              pt: 1.5,
              flex: '1 1 auto',
              minWidth: 0,
            },
            '& .RaSimpleFormIterator-action': {
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
          }}
        >
          {languages.map((lang) => (
            <TextInput key={lang.id} source={lang.id} label={lang.label} fullWidth />
          ))}
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
)

export const ChecklistShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <RichTextField source="description" />
      <BooleanField source="isPaymentRequired" />
      <ArrayField source="checks">
        <Datagrid>
          {languages.map((lang) => (
            <TextField key={lang.id} source={lang.id} label={lang.label} />
          ))}
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
)
